import * as type from '../type';
import * as contact from '../../api/contact';

const state = {};

const actions = {
    contactGetList({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            contact.getList(
                payload.employer_id
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject(error);
            })
        })
    },
    contactGetDetail({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            contact.getDetail(
                payload.employer_id,
                payload.client_user_id
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject(error);
            })
        })
    },
    contactGetPayLog({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            contact.getPayLog(
                payload.employer_id,
                payload.client_user_id
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject(error);
            })
        })
    },
    contactGetProjectList({
        state,
        commit
    }, payload) {
        return new Promise((resolve, reject) => {
            contact.getProjectList(
                payload.employer_id,
                payload.client_user_id
            ).then(res => {
                if (res.data.res_code == 1) {
                    resolve(res.data.msg);
                } else {
                    reject(res.data.msg);
                }
            }).catch(error => {
                console.error(error);
                reject(error);
            })
        })
    }
};

const mutations = {};

export default {
    state,
    actions,
    mutations
}